<template>
  <v-card>
    <v-card-title>
      {{$t('LoginPage.ResetForm.header')}}
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field 
          v-model="email" 
          :label="$t('LoginPage.Form.email')" 
          id="email" 
          prepend-icon="email" 
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        text
        color="grey" 
        @click="$emit('cancel')" 
      >
        {{$t('Global.Action.cancel')}}
      </v-btn>
      <v-btn 
        color="primary" 
        :loading="loading" 
        @click="submit" 
        :disabled="!email"
      >
        {{$t('Global.Action.confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { INVALID_EMAIL } from '@/config/errors'
import { ResetPasswordService, Utils } from '@portal/api'
export default {
  name: 'TheForgotPasswordForm',
  data: () => ({
    loading: false,
    email: ''
  }),
  methods: {
    async submit () {
      this.loading = true
      try {
        await ResetPasswordService.requestReset(this.email)
        this.$emit('submitted')
      } catch (error) {
        if (Utils.parseErrorDetail(error) === INVALID_EMAIL) {
          this.$emit('error', this.$t('Cette adresse email n\'est pas valide'))
        } else {
          this.$emit('error', this.$t('LoginPage.Error.askResetPassword'))
        }
      }
      this.loading = false
    }
  }
}
</script>